module.exports = __webpack_public_path__ + "img/PlanInformation.04fead32.png";